import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("terw_lang") : null;
    return saved === "en" || saved === "cs" ? saved : "cs";
  });

  useEffect(() => {
    localStorage.setItem("terw_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const dict = translations[lang] || translations.cs;
    const path = key.split(".");
    let v = dict;
    for (const p of path) {
      if (v && typeof v === "object" && p in v) v = v[p];
      else return key;
    }
    return v;
  };

  const toggleLang = () => setLang((l) => (l === "cs" ? "en" : "cs"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
